import { OfferingSummaryTypeEnum as OfferingType } from '@trybeapp/sdk'

/**
 * @deprecated
 * @see {OfferingType.Appointment}
 */
export const TYPE_APPOINTMENT = OfferingType.Appointment

/**
 * @deprecated
 * @see {OfferingType.AppointmentEnquiry}
 */
export const TYPE_APPOINTMENT_ENQUIRY = OfferingType.AppointmentEnquiry

/**
 * @deprecated
 * @see {OfferingType.AreaBooking}
 */
export const TYPE_AREA_BOOKING = OfferingType.AreaBooking

/**
 * @deprecated
 * @see {OfferingType.Course}
 */
export const TYPE_COURSE = OfferingType.Course
export const TYPE_GOLF = 'golf'

/**
 * @deprecated
 * @see {OfferingType.Membership}
 */
export const TYPE_MEMBERSHIP = OfferingType.Membership

/**
 * @deprecated
 * @see {OfferingType.Package}
 */
export const TYPE_PACKAGE = OfferingType.Package

/**
 * @deprecated
 * @see {OfferingType.TableReservation}
 */
export const TYPE_TABLE_RESERVATION = OfferingType.TableReservation

/**
 * @deprecated
 * @see {OfferingType.Product}
 */
export const TYPE_PRODUCT = OfferingType.Product

/**
 * @deprecated
 * @see {OfferingType.HotelRoomReservation}
 */
export const TYPE_HOTEL_ROOM_RESERVATION = OfferingType.HotelRoomReservation

/**
 * @deprecated
 * @see {OfferingType.Session}
 */
export const TYPE_SESSION = OfferingType.Session

/**
 * @deprecated
 * @see {OfferingType.Voucher}
 */
export const TYPE_VOUCHER = OfferingType.Voucher

export const FRIENDLY_TYPES = {
  [OfferingType.Appointment]: 'Appointment',
  [OfferingType.AppointmentEnquiry]: 'Appointment enquiry',
  [OfferingType.AreaBooking]: 'Area booking',
  [OfferingType.Course]: 'Course',
  [OfferingType.Membership]: 'Membership',
  [OfferingType.Package]: 'Package',
  [OfferingType.Product]: 'Product',
  [OfferingType.HotelRoomReservation]: 'Hotel room reservation',
  [OfferingType.TableReservation]: 'Table reservation',
  [OfferingType.Session]: 'Session',
  [OfferingType.Voucher]: 'Voucher',
}

export const OFFERING_TYPE_OPTIONS = [
  {
    value: OfferingType.Appointment,
    name: FRIENDLY_TYPES[OfferingType.Appointment],
  },
  {
    value: OfferingType.AreaBooking,
    name: FRIENDLY_TYPES[OfferingType.AreaBooking],
  },
  {
    value: OfferingType.Course,
    name: FRIENDLY_TYPES[OfferingType.Course],
  },
  {
    value: OfferingType.Membership,
    name: FRIENDLY_TYPES[OfferingType.Membership],
  },
  {
    value: OfferingType.Package,
    name: FRIENDLY_TYPES[OfferingType.Package],
  },
  {
    value: OfferingType.Product,
    name: FRIENDLY_TYPES[OfferingType.Product],
  },
  {
    value: OfferingType.Session,
    name: FRIENDLY_TYPES[OfferingType.Session],
  },
  {
    value: OfferingType.Voucher,
    name: FRIENDLY_TYPES[OfferingType.Voucher],
  },
  {
    value: OfferingType.HotelRoomReservation,
    name: FRIENDLY_TYPES[OfferingType.HotelRoomReservation],
  },
]
